import { faQuestionCircle, IconProp } from '~components/icon';

export interface MissingContent {
  header: string;
  descriptor: string;
  icon: IconProp;
}

const missingContentTypes: Record<string, MissingContent> = {
  appointment: {
    header: '404 - Appointment not found',
    descriptor: 'The appointment you are looking for does not exist.',
    icon: faQuestionCircle,
  },
  page: {
    header: '404 - Page Not Found',
    descriptor:
      'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
    icon: faQuestionCircle,
  },
};

export const getMissingContent = (type: string): MissingContent => {
  return missingContentTypes[type] ?? missingContentTypes['page'];
};
